export default __webpack_public_path__ + "static/media/home.2ae9b188.svg";